// Single source of truth for the StateProvinceIDs that have a dedicated online
// Province W-4 form. Mirrors TaxFormFactory.ImplementedProvinceStateIds on the backend
// (src/core/infrastructure/OnboardingDocument/TaxFormFactory.cs).
// A taxable state NOT in this list falls back to the paper/boilerplate flow.
// To add a new state form, add its StateProvinceID here (and wire the component + mapping).
export const IMPLEMENTED_PROVINCE_STATE_IDS: number[] = [5, 6, 7, 9, 12, 15, 19, 22, 32, 34, 35, 37, 48, 65];
